export default "__VITE_ASSET__CP0r4hwc__"